import Head from 'next/head';

type Props = {
  [key: string]: string;
};

const MetaTags = (props: Props) => {
  return (
    <Head>
      {Object.entries(props).map(([k, v], i) => {
        return <meta key={i} content={v} name={k} />;
      })}
    </Head>
  );
};

export default MetaTags;
